module.exports = __webpack_public_path__ + "public/img/animal_clinic.f049be63.png";